import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Element } from '../../types';
import { generateId } from '../../utils/Utils';
import '../add-timer-modal/AddTimerModal.css';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onAdd: (element: Element) => void;
}

export const AddTimeTrackerModal: React.FC<Props> = ({ isOpen, onClose, onAdd }) => {
    const { t } = useTranslation();
    const [title, setTitle] = useState('');

    if (!isOpen) return null;

    const close = () => {
        setTitle('');
        onClose();
    };

    const submit = () => {
        if (!title.trim()) return;
        onAdd({ id: generateId(), type: 'timeTracker', title: title.trim(), activities: [], segments: [] });
        close();
    };

    return <div className="add-timer-modal-overlay" onClick={close}>
        <div className="add-timer-modal" onClick={(event) => event.stopPropagation()}>
            <div className="add-timer-header">
                <div><h3>{t('addTimeTracker.title')}</h3><p>{t('addTimeTracker.subtitle')}</p></div>
                <button type="button" className="add-timer-close" onClick={close} aria-label={t('addTimeTracker.cancel')}><FontAwesomeIcon icon={faTimes} /></button>
            </div>
            <div className="add-timer-field">
                <label>{t('addTimeTracker.name')}</label>
                <input className="add-timer-input" value={title} onChange={(event) => setTitle(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') submit(); }} placeholder={t('addTimeTracker.namePlaceholder')} autoFocus />
            </div>
            <div className="add-timer-actions">
                <button type="button" className="add-timer-cancel" onClick={close}>{t('addTimeTracker.cancel')}</button>
                <button type="button" className="add-timer-submit" onClick={submit} disabled={!title.trim()}>{t('addTimeTracker.create')}</button>
            </div>
        </div>
    </div>;
};
